<div class="workspace bg-radial">
  <top-bar 
    class="accent"
    [isBackButtonShown]="true"
    backButtonText="{{ 'NAVIGATION.DASHBOARD' | translate }}"
    backButtonRouterLink="../../../"
    >
    <div nav-title class="col text-center">
      <h4>{{ "LESSONS.TITLE" | translate }}</h4>
    </div>
    <footer>
      <div class="row d-none d-md-flex">
        <div class="col-10">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item active" aria-current="page">
                {{ "LESSONS.TITLE" | translate }}
              </li>
            </ol>
          </nav>
        </div>
      </div>
    </footer>
  </top-bar>
  <div class="container">
    <div class="row pt-3 text-center">
      <!-- <p class="fs-3 text-muted">
        {{ "LESSONS.WORK_IN_PROGRESS" | translate }}
      </p> -->
      <p class="text-muted">
        {{ "LESSONS.WORK_IN_PROGRESS_INFO" | translate }}
      </p>
      <!-- <a class="btn-link text-decoration-none fs-3 pe-none">callan.app</a> -->
    </div>
  </div>
</div>
